var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1213)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_90_1213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_90_1213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5H2C1.45 0.5 1 0.95 1 1.5V8C1 8.275 1.225 8.5 1.5 8.5C1.775 8.5 2 8.275 2 8V2C2 1.725 2.225 1.5 2.5 1.5H7.5C7.775 1.5 8 1.275 8 1C8 0.725 7.775 0.5 7.5 0.5ZM9.5 2.5H4C3.45 2.5 3 2.95 3 3.5V10.5C3 11.05 3.45 11.5 4 11.5H9.5C10.05 11.5 10.5 11.05 10.5 10.5V3.5C10.5 2.95 10.05 2.5 9.5 2.5ZM9 10.5H4.5C4.225 10.5 4 10.275 4 10V4C4 3.725 4.225 3.5 4.5 3.5H9C9.275 3.5 9.5 3.725 9.5 4V10C9.5 10.275 9.275 10.5 9 10.5Z",
    fill: "#495057"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.aac9476d801cd0f4690072edc2401964.svg";
export { ForwardRef as ReactComponent };